module.exports = __webpack_public_path__ + "static/media/crudCustomer.9b4574fc.png";